<template>
  <main id="about-page">
    <ContentTitle :category="$t('sideMenu.Firmware')" :categoryIcon="'scf-traced'"
      :title="$t('sideMenu.CompaignList')" />

    <div style="max-width: 100%">
      <div class="row" style="
          align-content: flex-end;
          justify-content: flex-end;
          padding-top: 10px;
        "></div>
      <div class="row">
        <div class="col-md-12" v-if="componentKey > 0">
          <OdataFlexGrid :key="componentKey" :Api="{
            base: urlOdata + 'api/v1/OData/',
            controller: 'FirmwareCampaigns',
          }" :FiltersDefinition="FiltersDefinition" :ColumnsDefinition="columns" :FilterColumns="[
            'ExternalId',
            'Manufacturer',
            'Description',
            'FirmwareVersion',
            'CampaingEndDate',
            'StatusEnum',
          ]" :requestHeaders="gridHeaders" :displayLang="culture" v-on:initializedGrid="gridInitialized" v-on:gridFilterChanged="gridFilterChanged"
            :GridId="'campaignlist2'" :ExportsButtons="{
              Header: ExportsHeader,
              DataSource: ExportsDataSource,
              Events: ExportsEvents,
            }" :WijmoLicense="config.value('VUE_APP_WIJMO_LICENCE')" v-on:format-columns="formatColumns"
            v-on:column-visibility-changed="componentKey++" />
        </div>
        <p></p>
      </div>
    </div>
  </main>
</template>

<script>
import { defineComponent, computed } from "vue";
import Swal from "sweetalert2";
import MainService from "../services/MainService";
import utils from "../Utils/libraries";
import Helper from "@/Utils/Helper";
import "sweetalert2/dist/sweetalert2.min.css";
import Configs from "../../configs";
import * as wijmo from "@grapecity/wijmo";
import OdataFlexGrid from "@supervision/vue-components/components/OdataFlexGrid.vue";
import ContentTitle from "@supervision/vue-components/components/ContentTile";

export default defineComponent({
  name: "CompaignList",
  inject: ["accessToken", "routePrefix", "currentScope"],
  components: {
    OdataFlexGrid,
    ContentTitle,
  },
  beforeCreate() {
    this.currentScopeView = this.currentScope ?? this.$jwt.scope;
  },
  created() {
    this.currentScopeView = this.currentScope ?? this.$jwt.scope;
  },
  mounted() {
    if (this.currentScopeView) {
      this.componentKey += 1;
    }
  },
  watch: {
    currentScope: {
      handler: function (newVal) {
        if (newVal) {
          this.currentScopeView = newVal;
          this.mainService = new MainService(this.$jwt.token, newVal);
          this.initFilterParameters();
          this.componentKey += 1;
        }
      },
      deep: true
    },
    accessToken(newVal) {
      if (newVal) {
        this.mainService = new MainService(newVal, this.currentScopeView);
      }
    },
    culture() {
      if (this.currentScopeView != null && this.currentScopeView !== '')
        this.componentKey += 1;
    }
  },
  data() {
    return {
      gridHeaders: {
        authorization: `bearer ${this.accessToken}`,
        'X-Current-Scope': computed(() => this.isPreselectedScope ? this.preselectedScope : this.currentScopeView),
        'X-Custom-Filters': computed(() => this.headerFilters),
      },
      componentKey: 0,
      currentScopeView: null,
      config: Configs,
      mainService: new MainService(this.$jwt.token, this.currentScopeView),
      theGrid: null,
      urlOdata: Configs.value("VUE_APP_WEBAPI"),
      culture: computed(() => this.$i18n.locale),
      latestDataState: null,
      columns: [
        {
          width: "80*",
          header: computed(() =>
            this.$t("pages.CompaignList.columns.ExternalId")
          ),
          binding: "ExternalId",
          dataType: 1,
        },
        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.CompaignList.columns.Manufacturer")
          ),
          binding: "Manufacturer",
          dataType: 1,
        },
        {
          width: "310*",

          header: computed(() =>
            this.$t("pages.CompaignList.columns.Description")
          ),
          binding: "Description",
          dataType: 1,
        },
        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.CompaignList.columns.FirmwareVersion")
          ),
          binding: "FirmwareVersion",
          dataType: 1,
        },
        {
          width: "100*",
          header: computed(() =>
            this.$t("pages.CompaignList.columns.CampaingEndDate")
          ),
          binding: "CampaingEndDate",
          dataType: 4,
        },
        {
          width: "120*",
          header: computed(() =>
            this.$t("pages.CompaignList.columns.StatusEnum")
          ),
          binding: "StatusEnum",
          dataType: 1,
        },
        {
          width: "70*",
          header: "Actions",

          dataType: 0,
        },
      ],
      FiltersDefinition: [
        {
          binding: "StatusEnum",
          hasValueFilter: true,
          hasConditionFilter: false,
          values: [
            {
              id: "Failed",
              label: computed(() => this.getTraductionState("Failed")),
            },
            {
              id: "TechnicalFailure",
              label: computed(() =>
                this.getTraductionState("TechnicalFailure")
              ),
            },
            {
              id: "Pending",
              label: computed(() => this.getTraductionState("Pending")),
            },
            {
              id: "Successful",
              label: computed(() => this.getTraductionState("Successful")),
            },
            {
              id: "InProgress",
              label: computed(() => this.getTraductionState("InProgress")),
            },
            {
              id: "PartiallySuccessful",
              label: computed(() =>
                this.getTraductionState("PartiallySuccessful")
              ),
            },
            {
              id: "Retry",
              label: computed(() => this.getTraductionState("Retry")),
            },
          ],
        },
        {
          binding: "ExternalId",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "Manufacturer",
          hasValueFilter: true,
          hasConditionFilter: false,
          // values: [
          //   { id: "DME", label: "DME" },
          //   {
          //     id: "SEN",
          //     label: "SEN",
          //   },
          //   { id: "ITW", label: "ITW" },
          // ],
        },
        {
          binding: "Description",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "FirmwareVersion",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
        {
          binding: "CampaingEndDate",
          hasValueFilter: false,
          hasConditionFilter: true,
        },
      ],
      ExportsHeader: { text: "Exports", icon: "scf-export" },
      ExportsDataSource: [
        { text: "Export as Csv", method: "exportCsv", icon: "scf-csv" },
        { text: "Export as Excel", method: "exportExcel", icon: "scf-excel" },
      ],
      ExportsEvents: {
        exportCsv: this.exportCsv,
        exportExcel: this.exportExcel,
      },
      exportRoot:
        Configs.value("VUE_APP_WEBAPI") +
        "api/v1/OData/FirmwareCampaigns/export?",
    };
    /*
       "Pending":"En attente",
    "InProgress":"En cours",
    "Successful":"Succès",
    "Failed":"Echec" ,
    "Retry" :"Revérification",  
    "TechnicalFailure":"Problème technique",
    "PartiallySuccessful":"Succès partiel"
    */
  },
  methods: {
    gridFilterChanged(data) {
      this.latestDataState = data;
    },
    exportExcel() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=excel`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=excel`;
      }

      console.log(exportUrl);

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes("campaignlist", type, "xlsx", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportCsv() {
      const filter =
        this.latestDataState !== null && this.latestDataState !== undefined
          ? this.latestDataState.filterDefinition
          : "";
      let exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&exporFormat=csv`;
      if (filter != "") {
        exportUrl = `${this.exportRoot}cultureName=${this.$i18n.locale}&filter=${filter}&exporFormat=csv`;
      }

      console.log(exportUrl);

      this.mainService
        .Export(exportUrl, this.gridHeaders)
        .then((response) => {
          console.log(response);
          const type = response.headers["content-type"];
          utils.DownloadBytes("campaignlist", type, "csv", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goToDetail() {
      this.$router.push({ path: this.$route.path + "/" + "e" });
    },
    gridInitialized(flexgrid) {
      this.theGrid = flexgrid;

      var showDescription = this.showDescriptionInSwal.bind(this);

      flexgrid.hostElement.addEventListener("click", function (e) {
        let action = e.target.getAttribute("action-type");
        if (!action) {
          return;
        }

        var hitTest = flexgrid.hitTest(e);
        var data = flexgrid.rows[hitTest.row].dataItem;
        this.$router.push({
          path: "/DmPortal/CampaignDetail/" + data.ExternalId,
        });
      });

      flexgrid.hostElement.addEventListener("click", function (e) {
        let action = e.target.getAttribute("action-type-description");
        if (!action) {
          return;
        }
        var hitTest = flexgrid.hitTest(e);
        var data = flexgrid.rows[hitTest.row].dataItem;
        showDescription(data.Description);
      });
    },

    formatColumns: function (s, e) {
      const flex = s;

      if (e.panel == flex.cells) {
        if (flex.rows[e.row].dataItem.name) return;
        if (flex.columns[e.col].header == "Actions") {
          const prefix = Helper.ComputeRoutePrefix(this.routePrefix);

          e.cell.innerHTML =
            '<a class="scf-searchPlus"  target="_blank" style="color:#6095D6;text-decoration: none;" href="' +
            prefix +
            "/DmPortal/CampaignDetail/" +
            s.rows[e.row].dataItem.ExternalId +
            '"></a>';
          // e.cell.innerHTML =
          //  '<svg style="color:blue;cursor:pointer;" action-type="show" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16"><path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/></svg>';
        } else if (flex.columns[e.col].binding == "Description") {
          if (e.cell.textContent.trim().length > 20) {
            e.cell.innerHTML = wijmo.format(
              '<i action-type-description="showDescriptionInSwal">' +
              this.substringIfGreaterThanTweenty(e.cell.textContent.trim()) +
              "</i>",
              s.rows[e.row].dataItem
            );
          } else {
            e.cell.innerHTML = wijmo.format(e.cell.textContent.trim());
          }
        }
      }
    },

    showData(data) {
      window.alert(JSON.stringify(data));
    },
    getTraductionState: function (e) {
      return this.tryGetTranslation(`pages.CompaignList.State.${e}`);
    },
    tryGetTranslation(key) {
      return typeof this.$tm(key) == "string"
        ? this.$t(key)
        : key;
    },
    showmessage() {
      Swal.fire("functionality not yet specified", "", "info");
    },
    showDescriptionInSwal(e) {
      Swal.fire("", e, "");
    },
    substringIfGreaterThanTweenty(e) {
      if (e.length > 20) {
        return e.substring(0, 17).concat("", "...");
      } else return e;
    },
    async initFilterParameters() {
      await this.mainService
        .getDistinct("OData/FirmwareCampaigns", "Manufacturer")
        .then((response) => {
          if (
            typeof response.value != "undefined" &&
            response.value != null &&
            response.value.length != null &&
            response.value.length > 0
          ) {
            var obj = [];

            for (var i = 0; i < response.value.length; i++) {
              if (response.value[i].Manufacturer == null) {
                obj.push({
                  id: "nullValueFilter",
                  label: this.$t("common.nothing"),
                });
                continue;
              }
              obj.push({
                id: response.value[i].Manufacturer,
                label: response.value[i].Manufacturer,
              });
            }
            console.log(obj);
            this.FiltersDefinition.filter(
              (e) => e.binding == "Manufacturer"
            )[0].values = obj;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
});
</script>
<style lang="scss" scoped>
@import "../../node_modules/bootstrap/scss/bootstrap.scss";

#about-page {
  font-family: "D-DIN" !important;
}
</style>

<style scoped src="../assets/css/campaignList.css"></style>
